import Immutable from 'seamless-immutable';
import { combineReducers } from 'redux';

import * as actionTypes from './action-types';

const byIdInitialState = Immutable({});

function byId(state = byIdInitialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_TEAM_MEMBERSHIP.START:
      const { teamMembershipId: fetchingTeamMembershipId } = action.payload;
      return fetchingTeamMembershipId
        ? state.merge(
            {
              [fetchingTeamMembershipId]: {
                fetching: true,
              },
            },
            { deep: true }
          )
        : state;
    case actionTypes.FETCH_TEAM_MEMBERSHIP.SUCCESS:
      const { teamMembershipId: fetchedTeamMembershipId } = action.payload;
      return fetchedTeamMembershipId
        ? state.merge(
            {
              [fetchedTeamMembershipId]: {
                fetching: false,
                lastFetchedAt: new Date().toISOString(),
                error: null,
              },
            },
            { deep: true }
          )
        : state;
    case actionTypes.FETCH_TEAM_MEMBERSHIP.FAILURE:
      const { teamMembershipId: fetchErrorTeamMembershipId, error: fetchError } = action.payload;
      return fetchErrorTeamMembershipId
        ? state.merge(
            {
              [fetchErrorTeamMembershipId]: {
                fetching: false,
                error: fetchError,
              },
            },
            { deep: true }
          )
        : state;
    case actionTypes.CHECK_ACCEPT_TEAM_MEMBERSHIP_STATUS.START:
      const { teamMembershipId: checkingAcceptTeamMembershipStatusOfId } = action.payload;
      return checkingAcceptTeamMembershipStatusOfId
        ? state.merge(
            {
              [checkingAcceptTeamMembershipStatusOfId]: {
                checkingAcceptTeamMembershipStatus: true,
              },
            },
            { deep: true }
          )
        : state;
    case actionTypes.CHECK_ACCEPT_TEAM_MEMBERSHIP_STATUS.SUCCESS:
      const { teamMembershipId: checkedAcceptTeamMembershipStatusOfId } = action.payload;
      return checkedAcceptTeamMembershipStatusOfId
        ? state.merge(
            {
              [checkedAcceptTeamMembershipStatusOfId]: {
                checkingAcceptTeamMembershipStatus: false,
                lastCheckedAcceptTeamMembershipStatusAt: new Date().toISOString(),
              },
            },
            { deep: true }
          )
        : state;
    case actionTypes.CHECK_ACCEPT_TEAM_MEMBERSHIP_STATUS.FAILURE:
      const { teamMembershipId: checkedFailedAcceptTeamMembershipStatusOfId } = action.payload;
      return checkedFailedAcceptTeamMembershipStatusOfId
        ? state.merge(
            {
              [checkedFailedAcceptTeamMembershipStatusOfId]: {
                checkingAcceptTeamMembershipStatus: false,
              },
            },
            { deep: true }
          )
        : state;
    case actionTypes.ACCEPT_TEAM_MEMBERSHIP.START:
      const { teamMembershipId: acceptingTeamMembershipId } = action.payload;
      return acceptingTeamMembershipId
        ? state.merge({ [acceptingTeamMembershipId]: { accepting: true } }, { deep: true })
        : state;
    case actionTypes.ACCEPT_TEAM_MEMBERSHIP.SUCCESS:
    case actionTypes.ACCEPT_TEAM_MEMBERSHIP.FAILURE:
      const { teamMembershipId: acceptedTeamMembershipId } = action.payload;
      return acceptedTeamMembershipId
        ? state.merge({ [acceptedTeamMembershipId]: { accepting: false } }, { deep: true })
        : state;
    case actionTypes.REJECT_TEAM_MEMBERSHIP.START:
      const { teamMembershipId: rejectingTeamMembershipId } = action.payload;
      return rejectingTeamMembershipId
        ? state.merge({ [rejectingTeamMembershipId]: { rejecting: true } }, { deep: true })
        : state;
    case actionTypes.REJECT_TEAM_MEMBERSHIP.SUCCESS:
    case actionTypes.REJECT_TEAM_MEMBERSHIP.FAILURE:
      const { teamMembershipId: rejectedTeamMembershipId } = action.payload;
      return rejectingTeamMembershipId
        ? state.merge({ [rejectedTeamMembershipId]: { rejecting: false } }, { deep: true })
        : state;
    case actionTypes.REVOKE_TEAM_MEMBERSHIP.START:
      const { teamMembershipId: revokingTeamMembershipId } = action.payload;
      return revokingTeamMembershipId
        ? state.merge({ [revokingTeamMembershipId]: { revoking: true } }, { deep: true })
        : state;
    case actionTypes.REVOKE_TEAM_MEMBERSHIP.SUCCESS:
    case actionTypes.REVOKE_TEAM_MEMBERSHIP.FAILURE:
      const { teamMembershipId: revokedTeamMembershipId } = action.payload;
      return revokedTeamMembershipId
        ? state.merge({ [revokedTeamMembershipId]: { revoking: false } }, { deep: true })
        : state;
    default:
      return state;
  }
}

const byUserIdInitialState = Immutable({});

function byUserId(state = byUserIdInitialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_TEAM_MEMBERSHIPS_BY_USER_ID.START:
      const { userId: fetchingUserId } = action.payload;
      return state.merge(
        {
          [fetchingUserId]: {
            fetching: true,
          },
        },
        { deep: true }
      );
    case actionTypes.FETCH_TEAM_MEMBERSHIPS_BY_USER_ID.SUCCESS:
      const { userId: fetchedUserId } = action.payload;
      return state.merge(
        {
          [fetchedUserId]: {
            fetching: false,
            lastFetchedAt: new Date().toISOString(),
            error: null,
          },
        },
        { deep: true }
      );
    case actionTypes.FETCH_TEAM_MEMBERSHIPS_BY_USER_ID.FAILURE:
      const { userId: fetchFailedUserId, error: fetchError } = action.payload;
      return (
        state.merge({
          [fetchFailedUserId]: {
            fetching: false,
            error: fetchError,
          },
        }),
        { deep: true }
      );
    default:
      return state;
  }
}

export default combineReducers({
  byId,
  byUserId,
});



// WEBPACK FOOTER //
// ./src/store/features/users/team-memberships/reducer.js